'use client'

import { useMutation } from '@tanstack/react-query'
import { useRouter } from 'next/navigation'
import { useCallback } from 'react'
import { toast } from 'react-toastify'
import { LOGIN_SUCCESS_MESSAGE } from '@/constants/auth'
import { getPostLoginPath } from '@/services/domain/auth/SessionService'
import { ILoginRequest } from '~/schemas/auth/authSchemas'
import { loginService } from '~/services/domain/auth/LoginService'

/**
 * Login com e-mail e senha. Abre a sessão (cookie, useAuthStore e carrinho) e leva ao `redirect`, ou ao checkout se o
 * carrinho tem itens, ou à home. `login` rejeita com o ApiError depois do aviso de credencial errada.
 */
export function useLogin() {
    const router = useRouter()

    const loginMutation = useMutation({
        mutationFn: ({ credentials }: { credentials: ILoginRequest; redirect?: string }) => loginService(credentials),
        onSuccess: (session, { redirect }) => {
            toast.success(LOGIN_SUCCESS_MESSAGE, { autoClose: 2000 })
            router.push(getPostLoginPath(session, redirect))
        },
    })

    const login = useCallback(
        (credentials: ILoginRequest, redirect?: string) => loginMutation.mutateAsync({ credentials, redirect }),
        [loginMutation.mutateAsync],
    )

    return { login, isLoading: loginMutation.isPending, error: loginMutation.error }
}
